// extracted by mini-css-extract-plugin
export default {"linearProgress":"SkillBox_linearProgress__BcFQc","barColorPrimary":"SkillBox_barColorPrimary__LncpK"};